import { FormField, Toggle, Multiselect, SpaceBetween } from '@amzn/awsui-components-console';
import React, { useEffect, useState } from 'react';

/**
 * A form field component of custom config
 * @param {*} props
 * @returns
 */
export default function ConfigFormField(props) {
    /**
     * process set default event
     * @param {*} checked
     */
    const onChangeChecked = (checked) => {
        props.setChecked(checked);
        if (checked) {
            props.setSelectionDisabled(true);
        } else {
            props.setSelectionDisabled(false);
        }
    };
    return (
        <FormField label={props.label} description={props.description}>
            <SpaceBetween direction="vertical" size="s">
                <Toggle onChange={({ detail }) => onChangeChecked(detail.checked)} checked={props.checked}>
                    Default
                </Toggle>
                <Multiselect
                    selectedOptions={props.selectedOptions}
                    onChange={({ detail }) => props.setSelectedOptions(detail.selectedOptions)}
                    filteringType="auto"
                    options={props.options}
                    placeholder="Choose options"
                    disabled={props.selectionDisabled}
                />
            </SpaceBetween>
        </FormField>
    );
}
